import { Box } from '@mui/material';
import { DetailView } from '@pro4-erp/core-web';
import { useTranslation } from 'react-i18next';
import Answers from './Answers';
import Files from './Files';
import { AuditorVisitDetail } from '../types';
import ReturnedDocsFiles from './ReturnedDocsFiles';

const AuditorFiles = ({ visit }: { visit: AuditorVisitDetail }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <DetailView
        childrenSx={{ padding: '2rem' }}
        tabs={[
          {
            id: 'files-templates',
            title: t('Document templates', { defaultValue: 'Document templates' }),
          },
          { id: 'files', title: t('Business documents', { defaultValue: 'Business documents' }) },
          {
            id: 'files-returnedDocs',
            title: t('Returned documentation', { defaultValue: 'Returned documentation' }),
          },
          // { id: 'files-report', title: t('Report files', { defaultValue: 'Report files' }) },
          { id: 'answers', title: t('Answers', { defaultValue: 'Answers' }) },
        ]}
        defaultTab="files-templates"
      >
        {({ TabContent }) => (
          <>
            <TabContent tab="files">
              <Files />
            </TabContent>
            <TabContent tab="files-templates">
              <Files isTemplates />
            </TabContent>
            {/* <TabContent tab="files-report">
              <Files isReport />
            </TabContent> */}
            <TabContent tab="files-returnedDocs">
              <ReturnedDocsFiles />
            </TabContent>
            <TabContent tab="answers">
              <Answers answers={visit.answers} />
            </TabContent>
          </>
        )}
      </DetailView>
    </Box>
  );
};

export default AuditorFiles;
